document.addEventListener('click', (event) => {
  const checkoutButton = document.querySelector('.button-checkout');
  if (checkoutButton.contains(event.target) && is_draft_order && window.hulkappsCheckout != undefined) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    hulkappsCheckout();
  }
}, true);